import React, { useState } from "react";
import Icon from "components/AppIcon";

const HelpPanel = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="rounded-xl overflow-hidden" style={{ border: "1px solid var(--color-border)", background: "var(--color-card)" }}>
      <button
        className="w-full flex items-center justify-between px-4 py-3 transition-base"
        style={{ background: "var(--color-primary)10" }}
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center gap-2">
          <Icon name="HelpCircle" size={18} color="var(--color-primary)" />
          <span className="text-sm font-semibold" style={{ fontFamily: "var(--font-caption)", color: "var(--color-primary)" }}>
            ¿Cómo calcular el NIT?
          </span>
        </div>
        <Icon name={expanded ? "ChevronUp" : "ChevronDown"} size={16} color="var(--color-primary)" />
      </button>
      {expanded && (
        <div className="px-4 py-3 space-y-3">
          <p className="text-xs" style={{ fontFamily: "var(--font-caption)", color: "var(--color-muted-foreground)" }}>
            El NIT (Número de Identificación Tributaria) es asignado por la DIAN. Consta de:
          </p>
          <div className="space-y-2">
            {[
              { icon: "Hash", title: "Número base", desc: "8 a 10 dígitos sin puntos ni guiones" },
              { icon: "Calculator", title: "Dígito de verificación (DV)", desc: "1 dígito calculado mediante algoritmo oficial DIAN" },
              { icon: "FileText", title: "Formato en documentos", desc: "900.123.456-7 (con puntos y guión)" },
            ]?.map((item, i) => (
              <div key={i} className="flex items-start gap-2">
                <div className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: "var(--color-primary)15" }}>
                  <Icon name={item?.icon} size={12} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="text-xs font-semibold" style={{ fontFamily: "var(--font-caption)", color: "var(--color-foreground)" }}>{item?.title}</p>
                  <p className="text-xs" style={{ fontFamily: "var(--font-caption)", color: "var(--color-muted-foreground)" }}>{item?.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="rounded-lg p-3" style={{ background: "var(--color-muted)" }}>
            <p className="text-xs font-semibold mb-1" style={{ fontFamily: "var(--font-caption)", color: "var(--color-foreground)" }}>
              Ejemplo válido:
            </p>
            <p className="text-sm font-bold" style={{ fontFamily: "var(--font-data)", color: "var(--color-primary)" }}>
              900.123.456 - 7
            </p>
            <p className="text-xs mt-1" style={{ fontFamily: "var(--font-caption)", color: "var(--color-muted-foreground)" }}>
              Ingrese: <strong>900123456</strong> - DV: <strong>7</strong>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpPanel;